import { useProvideInject } from "../lib/provideInjectGenerator";
import { BetData } from "@fresh8/types/src/betData";
import {
  AdTag,
  CasinoData,
  CasinoDataError,
  CasinoDataPending,
  CasinoDataSuccess
} from "@fresh8/types/src/index";

export const AdTagSymbol = Symbol("AdTagSymbol");
export const {
  provider: provideAdTag,
  injector: injectAdTag
} = useProvideInject<AdTag>(AdTagSymbol, {} as AdTag);

export const BetDataSymbol = Symbol("BetDataSymbol");
export const {
  provider: provideBetData,
  injector: injectBetData
} = useProvideInject<BetData>(BetDataSymbol, {} as BetData);

export const CarouselSymbol = Symbol("carouselContext");
export const {
  provider: provideCarouselContext,
  injector: injectCarouselContext
} = useProvideInject<{ isCarousel: boolean; itemsOnView: number }>(
  CarouselSymbol,
  {
    isCarousel: false,
    itemsOnView: 0
  }
);

export const DisplayOverlaySymbol = Symbol("DisplayOverlayContext");
export const {
  provider: provideDisplayOverlay,
  injector: injectDisplayOverlay
} = useProvideInject<boolean>(DisplayOverlaySymbol, false);

export const CasinoDataSymbol = Symbol("casinoDataContext");
export const {
  provider: provideCasinoData,
  injector: injectCasinoData
} = useProvideInject<CasinoData>(CasinoDataSymbol, {
  status: "pending",
  data: null
});

export function isSuccess(
  possibleSuccess: CasinoData
): possibleSuccess is CasinoDataSuccess {
  return possibleSuccess.status === "success";
}

export function isPending(
  possiblePending: CasinoData
): possiblePending is CasinoDataPending {
  return possiblePending.status === "pending";
}

export function isError(
  possibleError: CasinoData
): possibleError is CasinoDataError {
  return possibleError.status === "error";
}
